export const formatCurrency=(value)=> {
  if (value===null || value===undefined) return '—';
  
  const abs=Math.abs(value);
  if (abs >=1e9) {
    return `${(value / 1e9).toFixed(abs >=10e9 ? 0 : 1)}B`;
  } else if (abs >=1e6) {
    return `${(value / 1e6).toFixed(abs >=10e6 ? 0 : 1)}M`;
  } else if (abs >=1e3) {
    return `${(value / 1e3).toFixed(abs >=10e3 ? 0 : 1)}K`;
  } else if (abs >=1) {
    return value.toFixed(1);
  } else {
    return value.toFixed(2);
  }
};

export const formatPercent=(value)=> {
  if (value===null || value===undefined) return '—';
  return `${value.toFixed(1)}%`;
};

export const formatUnits=(value)=> {
  if (value===null || value===undefined) return '—';
  // Return actual integer values for quantity sold
  return Math.round(value).toString();
};

export const formatDelta=(delta,percent,monochrome=false)=> {
  if (delta===null || delta===undefined) return '';
  
  const symbol=delta >=0 ? '▲' : '▼';
  const colorClass=monochrome ? '' : delta >=0 ? 'text-brand-good' : 'text-brand-bad';
  
  return {
    symbol,
    colorClass,
    value: formatCurrency(Math.abs(delta)),
    percent: formatPercent(Math.abs(percent))
  };
};